import * as errors from "../errors.js";
import { state } from "../state.js";

/*
    The mathematical function LOG is a natural logarithm with the basis e(E). If the term is 0 or negative the BASIC error ?ILLEGAL QUANTITY ERROR IN 
    line occurs. When the number is over 1.7014118342E+38 the BASIC-error ?OVERFLOW ERROR IN line appears. When the numeric argument is absent, a 
    ?SYNTAX ERROR IN line appears. 
*/
export const log = async (args) => {
    // If no args are given, throw a syntax error.
    if (args.length === 0) {
        throw new errors.SyntaxError();
    }

    // Check if the args is a number.
    if (isNaN(args)) {
        throw new errors.TypeMismatchError();
    }

    // Check for illegal quantity.
    if (args <= 0) {
        throw new errors.IllegalQuantityError();
    }

    // Check for overflow.
    if (Math.abs(args) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Calculate the logarithm.
    const result = Math.log(args);

    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Return the result.
    return result;
};